<template>
  <v-alert v-if="errors" type="warning" color="color_warning">
    <v-sheet
      v-for="(error, i) in errors"
      :key="'error-' + i"
      color="color_warning"
    >
      <div v-for="(regle, j) in error[0]" :key="'regle-' + j">
        <ul>
          <li v-for="(elem, k) in error[0]" :key="'div-' + k">
            {{ elem[0][0] }}
          </li>
        </ul>
      </div>
    </v-sheet>
  </v-alert>
</template>

<script>
export default {
  name: "AlertCreateFacture",
  props: {
    errors: {
      type: Array,
      default: null,
    },
  },
};
</script>

<style scoped></style>
